import {
  ApplicationConfig,
  APP_INITIALIZER,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  MsalService,
  MSAL_INSTANCE,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  IPublicClientApplication,
} from '@azure/msal-browser';
import { Observable } from 'rxjs';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { notificationInterceptor } from './core/interceptors/notification.interceptor';
import { AuthService } from './core/auth/auth.service';

function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: environment.msalConfig.auth,
    cache: { cacheLocation: 'localStorage' },
  });
}

function initAuth(authService: AuthService): () => Observable<void> {
  return () => authService.init();
}

const msalProviders = environment.authMock
  ? []
  : [
      { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
      MsalService,
    ];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, notificationInterceptor])),
    ...msalProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService],
      multi: true,
    },
  ],
};
